module.exports = __webpack_public_path__ + "img/phone-type.e7592ebd.svg";